// SL.L1a-1 (#2957, ruling 1 of 6254753350) — which issues the board shows
// for a sprint selection.
//
// An issue belongs to a sprint when its backlogItemId names an item in that
// sprint's GET /sprints `items` (backlog_items.sprint_id, the close gate's own
// rule). So a carried item's issue follows it to the next sprint. Never
// sprintRef (null on main) and never the legacy text sprintId (unmatchable).
//
// Until SL.D1 (#2951) links issues at sprint approval, most issues are
// unlinked. All active shows them alongside the active sprints' issues, with a
// note; a single sprint hides them and shows how many it hid.
import type { Sprint } from './sprintsApi';

export const ALL_ACTIVE = 'all-active';
export const CLOSED_SPRINTS = 'closed';

/** ALL_ACTIVE, CLOSED_SPRINTS, or one sprint's id. */
export type BoardSelection = string;

export function scopeBoardIssues<T extends { backlogItemId: string | null; status: string }>(
  issues: readonly T[],
  sprints: readonly Sprint[],
  selection: BoardSelection,
): { shown: T[]; unlinked: number } {
  const sprintOfItem = new Map<string, string>();
  for (const s of sprints) for (const it of s.items) if (it.sprintId) sprintOfItem.set(it.id, it.sprintId);
  const sprintOf = (i: T) => (i.backlogItemId ? sprintOfItem.get(i.backlogItemId) : undefined) ?? null;
  const active = new Set(sprints.filter((s) => s.state === 'active').map((s) => s.id));
  const shown = selection === ALL_ACTIVE
    ? issues.filter((i) => {
      const s = sprintOf(i);
      return s === null || active.has(s);
    })
    : issues.filter((i) => sprintOf(i) === selection);
  // Counted as the board would show them: cancelled issues never appear.
  const unlinked = issues.filter((i) => i.status !== 'CANCELLED' && sprintOf(i) === null).length;
  return { shown, unlinked };
}
